import React from "react";

import { twMerge } from "tailwind-merge";

import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";

import Checkbox from "components/Checkbox";
import FilterDropdown from "components/FilterDropDown";
import FontAwesomeIcon from "components/FontAwesomeIcon";
import RegionsFilter from "components/InsightsListFilters/RegionsFilter";

import Chips from "./Chips";
import SelectDeselectAll from "./SelectDeselectAll";
import { MARKET_CAPS } from "./utils";

const IsRequired = ({ message }: { message: string }) => (
  <>
    <FontAwesomeIcon
      className="text-[#C94961] ml-[5px]"
      icon={faExclamationCircle}
    />{" "}
    <span className="md:block text-[#C94961] font-bold text-[13px]">
      {message}
    </span>{" "}
  </>
);

const Interests = ({
  geographies,
  sectors,
  contentVerticals,
  selectedMarketCap,

  selectedMandates,
  onSelectDeselectAll,
  onChangeCheckbox,
  onSelectMarketCap,
  setSelectedCountries,
  onRemoveCountry,
}: any) => {
  const isRegionsCountriesRequired =
    (!selectedMandates.geographies ||
      selectedMandates.geographies?.length === 0) &&
    (!selectedMandates.countries || selectedMandates.countries?.length === 0);
  const isSectorsRrequired =
    !selectedMandates.sectors || selectedMandates.sectors?.length === 0;
  const isContentVerticalsRrequired =
    !selectedMandates.contentVerticals ||
    selectedMandates.contentVerticals?.length === 0;

  return (
    <>
      <div className="flex flex-col md:flex-row space-y-[15px] md:space-y-0">
        <div className="md:w-[150px] text-[18px] font-medium">
          Regions
          {isRegionsCountriesRequired && (
            <IsRequired message="Atleast 1 region or country required" />
          )}
        </div>
        <div className="flex-2">
          <SelectDeselectAll
            onSelectAll={() => onSelectDeselectAll("geographies")}
            onDeselectAll={() => onSelectDeselectAll("geographies", false)}
          />
          <div className="flex flex-col space-y-2 min-w-[320px]">
            {geographies?.map((i: any) => (
              <Checkbox
                checked={selectedMandates.geographies?.find?.(
                  (j: string) => j.toLowerCase() === i.name.toLowerCase()
                )}
                key={i.id}
                onChange={({ currentTarget }) =>
                  onChangeCheckbox("geographies", i.name, currentTarget)
                }
              >
                {i.name}
              </Checkbox>
            ))}
          </div>
        </div>
        <div className="flex-1">
          <div className="flex">
            <div className="md:w-[150px] text-[18px] font-medium">
              Countries
            </div>
            <FilterDropdown
              className="bg-transparent text-active-black"
              dropdown={
                <RegionsFilter
                  selected={{
                    countries:
                      selectedMandates.countries.map((name: string) => ({
                        name,
                      })) || [],
                  }}
                  onCountriesChange={(selectedCountries) =>
                    setSelectedCountries(selectedCountries.map((c) => c.name))
                  }
                  showTopCountries
                />
              }
            >
              Add Specific Country
            </FilterDropdown>
          </div>
          <Chips
            items={selectedMandates.countries}
            onRemove={onRemoveCountry}
          />
        </div>
      </div>

      <div className="flex flex-col md:flex-row space-y-[10px] md:space-y-0">
        <div className="md:w-[150px] text-[18px] font-medium">
          Sectors
          {isSectorsRrequired && <IsRequired message="is required" />}
        </div>
        <div>
          <SelectDeselectAll
            onSelectAll={() => onSelectDeselectAll("sectors")}
            onDeselectAll={() => onSelectDeselectAll("sectors", false)}
          />
          <div className="space-y-2 md:space-y-0 md:grid md:grid-cols-3 md:gap-x-6 md:gap-y-2">
            {sectors?.map((i: any) => (
              <Checkbox
                checked={selectedMandates.sectors?.includes?.(i.name)}
                key={i.id}
                onChange={({ currentTarget }) =>
                  onChangeCheckbox("sectors", i.name, currentTarget)
                }
              >
                {i.name}
              </Checkbox>
            ))}
          </div>
        </div>
      </div>

      <div className="flex flex-col md:flex-row space-y-[10px] md:space-y-0 w-full">
        <div className="md:w-[150px] text-[18px] font-medium">
          Verticals
          {isContentVerticalsRrequired && <IsRequired message="is required" />}
        </div>
        <div>
          <SelectDeselectAll
            onSelectAll={() => onSelectDeselectAll("contentVerticals")}
            onDeselectAll={() => onSelectDeselectAll("contentVerticals", false)}
          />
          <div className="space-y-2 md:space-y-0 md:grid md:grid-cols-3 md:gap-x-6 md:gap-y-2">
            {contentVerticals?.map((i: any) => (
              <Checkbox
                checked={selectedMandates.contentVerticals?.includes?.(i.id)}
                key={i.id}
                onChange={({ currentTarget }) =>
                  onChangeCheckbox("contentVerticals", i.id, currentTarget)
                }
                tooltip={i.description}
              >
                {i.name}
              </Checkbox>
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row space-y-[10px] md:space-y-0 w-full">
        <div className="md:w-[150px] text-[18px] font-medium">Market Cap</div>
        <div className={twMerge("w-full md:pl-[20px]")}>
          <div>
            <div className="flex border border-solid border-shady-gray divide-x divide-y-0 divide-solid divide-shady-gray rounded-lg overflow-hidden">
              {MARKET_CAPS.map((item) => (
                <div
                  key={item.id}
                  className={twMerge(
                    "flex-1 py-[15px] text-center cursor-pointer text-gray-gray",
                    selectedMarketCap?.id === item.id &&
                      "bg-smart-teal text-white"
                  )}
                  onClick={() => onSelectMarketCap(item)}
                >
                  {item.text}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Interests;
